import { render } from "./international-country-table.vue?vue&type=template&id=1de815a2&ts=true"
import script from "./international-country-table.vue?vue&type=script&lang=ts"
export * from "./international-country-table.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__